import React from "react";
import ProfileAvatar from "../../assets/components/ProfileAvatar";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import UserProfileMenu from "./ProfileMenu";

const ProfilePage = () => {
  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        <ProfileAvatar showInfo={true} />
        <UserProfileMenu />
      </div>
    </AnimatedPageContainer>
  );
};

export default ProfilePage;
